import React, {useState, useRef} from 'react';
import {TopBar} from '@shopify/polaris';
import {SearchProvider} from '@thinkwell/react.common';
import {AppProvider} from '@thinkwell/react.polaris';
import { ProductProvider } from '../contexts/Product'
import { CoursesProvider } from '../contexts/Courses'
import Product from './Product'
import EditProduct from './EditProduct'
import MainFrame from '../MainFrame';

export default function Show(props) {
  const navigateToRef = useRef()
  const [search, setSearch] = useState()
  const [addProductActive, setAddProductActive] = useState(false);
  const [isProductMenuOpen, setIsProductMenuOpen] = useState(false);
  const toggleIsProductMenuOpen = () => setIsProductMenuOpen((isProductMenuOpen) => !isProductMenuOpen);

  const productMenuMarkup = (
     <TopBar.UserMenu
       actions={[
         {
           items: [
             {content: 'Add Product', onAction: () => { setAddProductActive(true) }},
             {content: 'Logout', url: '/logout'}
           ]
         }
       ]}
       name="Products"
       initials="T"
       open={isProductMenuOpen}
       onToggle={toggleIsProductMenuOpen}
     />
   );

  const onSearchKeyPress = (event) => {
    const enterKeyPressed = event.keyCode === 13;
    if (enterKeyPressed) {
      event.preventDefault();
      navigateToRef.current(`products?q=${encodeURIComponent(search)}`)
    }
  }

  const onSearchChange = (value) => {
    setSearch(value)
  }

  const onAddProduct = (product) => {
    navigateToRef.current(`products/${product.id}`)
  }

  const onDeleteProduct = (product) => {
    navigateToRef.current(`products`)
  }

  return (
  <AppProvider>
    <SearchProvider>
      <MainFrame searchPlaceHolder={props.item.name} onSearchChange={onSearchChange}
      onSearchKeyPress={onSearchKeyPress} navigateToRef={navigateToRef} userMenu={productMenuMarkup}>
        <ProductProvider value={props.item}>
        { addProductActive ?
          <EditProduct
            active={addProductActive}
            onActive={(active) => { if (active != addProductActive) { setAddProductActive(active) }}}
            onSave={onAddProduct}
          /> : null
        }
        { !addProductActive ?
          <Product
            onDelete={onDeleteProduct}
            navigateToRef={navigateToRef}
          /> : null
        }
        </ProductProvider>
      </MainFrame>
    </SearchProvider>
  </AppProvider>)
}
